import { createAsyncThunk } from '@reduxjs/toolkit';
import { TFetchFormParams } from 'shared/common/types/form';
import { IThunkApi } from 'shared/common/types/redux';
import { fetchModalForm } from 'shared/owner/services/fetchModalForm';

export const sendModalForm = createAsyncThunk<string, TFetchFormParams, IThunkApi>(
  'form/sendModalForm',
  async (params, _thunkApi) => {
    const { rejectWithValue, extra } = _thunkApi;

    try {
      const response = await fetchModalForm(extra, params);

      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
